import React from 'react'
import HomeScreen from './HomeScreen'

function NewArrivalsScreen() {
  // HomeScreen already sorts by created date via backend default
  return <HomeScreen showHero={false} title="New Arrivals" />
}

export default NewArrivalsScreen


